module.exports = __webpack_public_path__ + "static/img/fefco215_2.ccfbb58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco215_2.png
// module id = XLut
// module chunks = 0